import React, { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { ButtonProps } from '@node-space/storybook-components/dist/Button'
import {
  Modal,
  ModalActions,
  ModalBody,
  ModalNavBar,
} from '@node-space/storybook-components/dist/Modal'
import { AccountContactTranslation } from 'components/accountContact/accountContactV2/constants'
import { Description } from 'components/Text'

export type IdVerificationMessageMessageAccountRepProps = {
  isLoading: boolean
  errorMessage?: ReactNode
  onBack: () => void
}

export const IdVerificationMessageAccountRep = ({
  isLoading,
  errorMessage,
  onBack,
}: IdVerificationMessageMessageAccountRepProps) => {
  const { t } = useTranslation()

  const actions: ButtonProps[] = [
    {
      loading: isLoading,
      children: t('continue'),
      type: 'submit',
    },
  ]

  return (
    <Modal visible closeModal={onBack}>
      <ModalNavBar
        title={t('accountContact.createIdVerificationLink.titleAccountRep')}
        onBack={onBack}
      />
      <ModalBody spaceChildren={24}>
        {!!errorMessage && errorMessage}
        <Description>
          {t(
            `accountContact.createIdVerificationLink.requirements.${AccountContactTranslation.ACCOUNT_REPRESENTATIVE}`
          )}
        </Description>
        <Description>{t('accountContact.createIdVerificationLink.appointAnother')}</Description>
      </ModalBody>
      <ModalActions actions={actions} />
    </Modal>
  )
}
